import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthModalStore = defineStore('authModal', () => {
  const visible = ref(false)
  /** 登录成功后跳转路径（可选） */
  const redirectPath = ref<string>('')
  /** 默认打开的 tab：login / register */
  const defaultMode = ref<'login' | 'register'>('login')

  function open(options?: { mode?: 'login' | 'register'; redirect?: string }): void {
    defaultMode.value = options?.mode ?? 'login'
    redirectPath.value = options?.redirect ?? ''
    visible.value = true
  }

  function close(): void {
    visible.value = false
    // 延迟清空，避免动画期间状态丢失
    setTimeout(() => {
      redirectPath.value = ''
      defaultMode.value = 'login'
    }, 300)
  }

  return {
    visible,
    redirectPath,
    defaultMode,
    open,
    close
  }
})
